import React, { Component } from 'react'
import Tooltip from '@components/Tooltip'
import DashIcon from '@components/Icon/Dash'
import moment from 'moment'
import CheckIcon from '@components/Icon/Check'
import { Link } from 'react-router-dom'
import DocumentTitle from 'react-document-title'
import GeneralFeesSearchPanel from './GeneralFeesSearchPanel'
import Action from '@components/Action'
import { inject, observer } from 'mobx-react'
import map from 'lodash/map'
import Download from '@components/Icon/Download'
import sumBy from 'lodash/sumBy'
import Pagination from '@components/Pagination'
import propTypes from 'prop-types'
import { formatDate, formatNumber } from '@atheneum/api/dist/lib'
import Spinner from '@components/spinner'
import Scroll from '@components/Scroll'
import './general-fees.sass'

function fmtNumber (number) {
  return formatNumber((number || 0) / 1e6)
}

function fmtMoney (money) {
  return formatNumber((money || 0) / 1e6) + ' EUR'
}

class GeneralFees extends Component {
  static propTypes = {
    generalFeesStore: propTypes.object,
    sidebarStore: propTypes.object,
    staticData: propTypes.object
  }

  constructor (props) {
    super(props)
    props.generalFeesStore.getAll()
  }

  renderDeliverable = deliverable => {
    const totals = {}
    const deliverableTypes = this.props.staticData.names.deliverableTypes
    const model = this.props.generalFeesStore.model
    const feesToShow = deliverable.expanded
      ? deliverable.fees
      : deliverable.fees
          .filter(
            i => !(this.props.generalFeesStore.model.noContract && i.contractId)
          )
          .filter(
            i =>
              moment(i.deliveryDate) >= moment(model.startDate) &&
              moment(i.deliveryDate).startOf('day') <= moment(model.endDate)
          )
          .filter(
            i =>
              this.props.generalFeesStore.model.feeType === 'ALL' ||
              i.type === this.props.generalFeesStore.model.feeType
          )
    return (
      <tbody key={deliverable.id}>
        <tr className='title'>
          <th colSpan={4} className='font-weight-normal'>
            <Link to={'/client-search/account/' + deliverable.clientAccountId}>
              {deliverable.clientAccount}
            </Link>
            {' - '}
            <Link to={'/project/' + deliverable.projectId}>
              {deliverable.projectName}
            </Link>
            {' - '}
            {deliverableTypes[deliverable.deliverableTypeId]}{' '}
            {feesToShow.length !== deliverable.fees.length && (
              <a
                href='#n'
                className='font-weight-normal'
                title='Click here to see all fees and costs included in this deliverable'
                onClick={e => {
                  e.preventDefault()
                  this.props.generalFeesStore.expand(deliverable.deliverableId)
                }}
              >
                expand deliverable
              </a>
            )}
          </th>
          <th className='center'>{totals.totalAmountUnits}</th>
          <th className='center'>
            {fmtMoney(sumBy(deliverable.fees, 'costConvertedValue'))}
          </th>
          <th className='center'>
            {fmtMoney(sumBy(deliverable.fees, 'feeConvertedValue'))}
          </th>
          <th className='center'>
            {fmtNumber(sumBy(deliverable.fees, 'feeCredits'))}
          </th>
          <th colSpan={3} />
        </tr>
        {feesToShow.map(this.renderFee)}
      </tbody>
    )
  }

  renderFee = fee => {
    return (
      <tr>
        <td>
          <span className='text-wrapper'>
            <Link to={`/project/${fee.projectId}/fee/${fee.feeId}`}>
              {fee.feeTypeId
                ? this.props.staticData.names.feeTypes[fee.feeTypeId]
                : this.props.staticData.names.costTypes[fee.costTypeId]}
            </Link>
            <span className='desc desc--top-spacing'>
              {fee.expertName || fee.employeeName}
            </span>
          </span>
        </td>
        <td>
          <span className='text-wrapper'>{formatDate(fee.deliveryDate)}</span>
        </td>
        <td>
          <span className='text-wrapper'>{fee.consultationDuration}</span>
        </td>
        <td>
          <span className='text-wrapper'>
            {map(fee.employees, e => (
              <div key={e.fullName}>{e.fullName}</div>
            ))}
          </span>
        </td>
        <td className='center'>
          <span className='text-wrapper'>
            {map(fee.employees, e => (
              <div key={e.fullName}>{fmtNumber(e.units)}</div>
            ))}
          </span>
        </td>
        <td className='center'>
          <span className='text-wrapper'>
            {fmtMoney(fee.costConvertedValue)}
          </span>
        </td>
        <td className='center'>
          <span className='text-wrapper'>
            {fmtMoney(fee.feeConvertedValue)}
          </span>
        </td>
        <td className='center'>
          <span className='text-wrapper'>{fmtNumber(fee.feeCredits)}</span>
        </td>
        <td className='center'>
          <a
            href={'/contract/' + fee.contractId}
            onClick={e => this.openContractSidebar(e, fee.contractId)}
          >
            <span className='text-wrapper'>{fee.contractReference}</span>
          </a>
        </td>
        <td className='center'>
          {fee.invoiceId ? (
            <Tooltip tooltip={fee.invoiceNumber} disabled>
              <div>
                <CheckIcon className='green-icon' />
              </div>
            </Tooltip>
          ) : (
            <DashIcon className='red-icon' />
          )}
        </td>
      </tr>
    )
  }

  renderTable (store) {
    if (!this.props.generalFeesStore.deliverables.length) {
      return <h3>No fees found</h3>
    }

    return (
      <div>
        <table className='table-wrapper--nested'>
          <thead>
            <tr>
              <th>Fee type / Expert name</th>
              <th>Delivery date</th>
              <th>Details</th>
              <th>Delivered employee</th>
              <th className='center'>Units</th>
              <th className='center'>Cost(EUR)</th>
              <th className='center'>Fee(EUR)</th>
              <th className='center'>Credits</th>
              <th className='center'>Contract</th>
              <th className='center'>Invoice</th>
              <th className='center' />
            </tr>
          </thead>
          {map(store.deliverables, this.renderDeliverable)}
        </table>
        <Pagination
          total={store.total}
          page={store.model.page}
          perPage={10}
          onChange={page => store.onPageChange(page)}
        />
      </div>
    )
  }

  renderActions = () => {
    if (!this.props.generalFeesStore.deliverables.length) return null
    return (
      <div className='invoice-wrapper animate-intro'>
        <div className='actions-wrapper  margin-bottom-35'>
          <ul className='actions left-list' />
          <ul className='actions right-list'>
            <li className='action'>
              <Action onClick={() => {
                this.props.generalFeesStore.export(this.props)
              }}>
                <Download />
                <span>Export Operational Report</span>
              </Action>
            </li>
          </ul>
        </div>
      </div>
    )
  }

  render () {
    const store = this.props.generalFeesStore

    return (
      <DocumentTitle title='Project search and listing | Atheneum Partners'>
        <div className='expert-search'>
          <GeneralFeesSearchPanel />

          <div className='revenues-view'>
            <Scroll>
              <div className='project-wrapper'>
                <div className='details-header'>
                  <div className='info info--noLeft'>
                    <div className='name-status-wrapper'>
                      <h1>General Fees</h1>
                    </div>
                  </div>
                  <div className='floating'>
                    <div>
                      <h1>
                        {store.fees && store.costs
                          ? (
                              ((store.fees - store.costs) / store.fees) *
                              100
                            ).toFixed(2) + '%'
                          : 'N/A'}
                      </h1>
                      <span>Margin</span>
                    </div>
                  </div>
                  <div className='floating'>
                    <div>
                      <h1>{fmtMoney(store.fees)}</h1>
                      <span>Fees</span>
                    </div>
                  </div>
                  <div className='floating'>
                    <div>
                      <h1>{fmtMoney(store.costs)}</h1>
                      <span>Costs</span>
                    </div>
                  </div>
                </div>
                {this.renderActions()}
                <div>
                  {store.loading ? <Spinner /> : this.renderTable(store)}
                  {store.error && <h2>Error fetching fees</h2>}
                </div>
              </div>
            </Scroll>
          </div>
        </div>
      </DocumentTitle>
    )
  }

  openContractSidebar = (e, contractId) => {
    e.preventDefault()
    this.props.sidebarStore.openSidebar({
      template: 'contract',
      id: contractId
    })
    return false
  }
}

export default inject('generalFeesStore', 'staticData', 'sidebarStore', 'queueProcessorStore')(
  observer(GeneralFees)
)
